function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { EnhanceComponent } from "../../middleware/EnhanceComponent";
import setting from "./setting";
import { getPrefixCls } from "../../utils/common";
import "./style.less";
import { Button } from "../../common";
import commonPool from "../../store/commonPool";
var prefixCls = getPrefixCls('SmMultiProducts');
var MultiProducts = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$schema, _props$schema$params, _productInfo$products;
  var title = props.title,
    copy = props.copy,
    fontColor = props.fontColor,
    fontSize = props.fontSize,
    modelBgColor = props.modelBgColor,
    selectBorderColor = props.selectBorderColor,
    selectFontColor = props.selectFontColor;
  var productInfo = props.productInfo || ((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$params = _props$schema.params) === null || _props$schema$params === void 0 ? void 0 : _props$schema$params.productInfo);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedProduct = _useState2[0],
    setSelectedProduct = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProductStatus = _useState4[0],
    setSelectedProductStatus = _useState4[1];
  var refs = commonPool.getRefs();
  useImperativeHandle(ref, function () {
    return {
      selectedProduct: selectedProduct,
      updateSelectProduct: updateSelectProduct
    };
  });
  useEffect(function () {
    setSelectedProduct(commonPool.getSelectedProduct());
  }, [selectedProductStatus]);
  var updateSelectProduct = function updateSelectProduct() {
    setSelectedProductStatus({});
  };
  var productList = productInfo !== null && productInfo !== void 0 && (_productInfo$products = productInfo.products) !== null && _productInfo$products !== void 0 && _productInfo$products.length ? productInfo === null || productInfo === void 0 ? void 0 : productInfo.products : [{
    id: '1',
    productName: '无数据占位',
    price: '100'
  }, {
    id: '2',
    productName: '无数据占位',
    price: '200'
  }];
  var onSpecificationsClick = function onSpecificationsClick(item) {
    setSelectedProduct(item);
    commonPool.setSelectedProduct(item);
    var refs = commonPool.getRefs();
    for (var key in refs) {
      if (Object.prototype.hasOwnProperty.call(refs, key)) {
        var _refs$key, _refs$key$ref, _refs$key$ref$current, _refs$key$ref$current2, _refs$key$ref$current3;
        (_refs$key = refs[key]) === null || _refs$key === void 0 ? void 0 : (_refs$key$ref = _refs$key.ref) === null || _refs$key$ref === void 0 ? void 0 : (_refs$key$ref$current = _refs$key$ref.current) === null || _refs$key$ref$current === void 0 ? void 0 : (_refs$key$ref$current2 = (_refs$key$ref$current3 = _refs$key$ref$current).updateSelectProduct) === null || _refs$key$ref$current2 === void 0 ? void 0 : _refs$key$ref$current2.call(_refs$key$ref$current3);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-specifications-product-select"),
    id: title ? "me-".concat(title) : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-specifications-products-tt")
  }, copy || '请选择你感兴趣的课程'), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-specifications-products-bd")
  }, productList === null || productList === void 0 ? void 0 : productList.map(function (item) {
    return /*#__PURE__*/React.createElement(Button, {
      className: "".concat(prefixCls, "-specific-item \n                        ").concat(selectedProduct && item.id === selectedProduct.id ? "".concat(prefixCls, "-checked") : ''),
      size: "small",
      key: item.id,
      onClick: function onClick() {
        return onSpecificationsClick(item);
      },
      style: {
        color: selectedProduct && item.id === selectedProduct.id ? selectFontColor : fontColor,
        fontSize: fontSize !== null && fontSize !== void 0 && fontSize.includes('px') ? fontSize : "".concat(fontSize, "px"),
        backgroundColor: modelBgColor,
        borderColor: selectedProduct && item.id === selectedProduct.id ? selectBorderColor : undefined
      }
    }, item.productName);
  })));
});
var EnhanceMultiProducts = EnhanceComponent(MultiProducts);
EnhanceMultiProducts.settings = setting;
export default EnhanceMultiProducts;